export default __webpack_public_path__ + "static/media/iwmi-pdf-footer-logo.a1bd9f7e.png";